<template>
  <div class="p-lg pb-leftSquiggleHeight">
    <h1>Add Personal Message Tab</h1>
    <div class="p-base mb-xl bg-signableBrandColours-white">
      <TabList
        :tabs="tabs"
        v-model="selected"
      />
      <TabGroup
        :tabs="tabs"
        :selected="selected"
      >
        <template v-slot:name>
          <div class="p-base h-appHeader">Name ...</div>
        </template>
        <template v-slot:password>
          <div class="p-base h-appHeader">Password ...</div>
        </template>
        <template v-slot:message>
          <PersonalMessageTab
            v-model="message"
          />
        </template>
        <template v-slot:messageWithValidationErrors>
          <PersonalMessageTab
            v-model="message2"
            :errors="errors"
          />
        </template>
      </TabGroup>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import { PersonalMessageTab } from '@/components/ui/envelopeCreate/steps/addRecipients/personalMessageTab';
import { TabList } from '@/components/library/tabs/TabList';
import { TabGroup } from '@/components/library/tabs/TabGroup';

const selected = ref('message');
const message = ref('');
const message2 = ref('Foo bar baz');

const errors = ref(['This is a validation error']);

const tabs = ref([
  {
    title: 'Name/Role',
    id: 'name',
    selected: false,
    dismissible: false,
  },
  {
    title: 'Password',
    id: 'password',
    selected: false,
    dismissible: false,
  },
  {
    title: 'Personal Message',
    id: 'message',
    selected: true,
    dismissible: false,
  },
  {
    title: 'Personal Message - with validation errors',
    id: 'messageWithValidationErrors',
    selected: false,
    dismissible: false,
  },
]);
</script>
